export const MAKE_ANALYTICS_CONSTANTS = {
  ACCORDION: {
    ACCORDION_ITEM_BUTTON: 'accordion-toggle-button',
  },
  ALERT: {
    PRIMARY_ACTION_BUTTON: 'alert-primary-action-button',
  },
  AVATAR: {
    AVATAR_BUTTON: 'avatar-button',
  },
  CARD: {
    FOOTER_PRIMARY_ACTION_BUTTON: 'card-footer-primary-action-button',
    FOOTER_SECONDARY_ACTION_BUTTON: 'card-footer-secondary-action-button',
  },
  DATE_PICKER: {
    CANCEL_BUTTON: 'date-picker-cancel-button',
    APPLY_BUTTON: 'date-picker-apply-button',
  },
  FILE_UPLOAD: {
    REUPLOAD_BUTTON: 'file-reupload-button',
  },
  SPOTLIGHT_POPOVER_TOUR: {
    FOOTER_PRIMARY_ACTION: 'spotlight-popover-tour-footer-primary-action-button',
    FOOTER_SECONDARY_ACTION: 'spotlight-popover-tour-footer-secondary-action-button',
  },
  TOAST: {
    ACTION_BUTTON: 'toast-action-button',
  },
};
